<template>
    <section class="section-questionnaire">
        <div class="inner">
            <div v-if="!displayFlg">
                <div class="ttl"
                     data-js="popupAnimation"
                     data-popupAnimation-state="notMoved"
                     data-popupAnimation-start="100"
                     data-popupAnimation-delay="0">
                    Did this article make you interested in<br />traveling to Japan?
                </div>
                <div class="answers"
                     data-js="popupAnimation"
                     data-popupAnimation-state="notMoved"
                     data-popupAnimation-start="100"
                     data-popupAnimation-delay="0">
                    <div class="d-flex justify-content-center">
                        <div class="d-flex justify-content-center">
                            <div class="border border-light rounded-circle answer" @click="sendAnswer(true)">Yes</div>
                        </div>
                        <div class="d-flex justify-content-center">
                            <div class="border border-light rounded-circle answer" @click="sendAnswer(false)">No</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="displayFlg">
                <img src="../../assets/luxury_travel/questionnaire.png" alt="">
                <div class="thank-you mt-5">
                    Thank you<br />for your feedback!
                </div>
            </div>
        </div>
    </section>

</template>

<script>
import ApiRouter from "@/components/Systems/ApiRouter.vue";

export default {
    name: "Questionnaire.vue",
    mixins: [ApiRouter],
    data: function() {
        return {
            displayFlg: false,
            answerValue: false,
            questionnaire: null,
            apiRequestSent: false,
        }
    },
    props: {
      pageId: {
          type: Number,
          required: true,
      }
    },
    methods: {
        sendAnswer(value) {
          if (!this.apiRequestSent) {
            this.apiRequestSent = true;
            this.answerValue = value;
            const postData = {
                answer: this.answerValue,
                pageId: this.$props.pageId,
            }
            window.axios.post(this.routes.questionnaire, postData)
                .then((response) => {
                    this.questionnaire = response.data.data;
                    this.displayFlg = true;
                })
          }
        },
    }
}
</script>

<style src="./Questionnaire.scss" lang="scss" scoped />
